"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 7px 3px;\n  padding-right: 13px;\n  background-color: ", ";\n  border-radius: 5px;\n  border: 1px solid #eaeaea;\n  margin: 2px;\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  span:first-child {\n    height: auto !important;\n    width: 36px !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Radio_1 = __importDefault(require("@material-ui/core/Radio"));

var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));

var __1 = require("..");

var StyledFormControlLabel = styled_components_1.default(FormControlLabel_1.default)(_templateObject(), function (props) {
  return props.style.bgColor;
}, function (props) {
  return props.style.selectedColor !== 'black' && styled_components_1.css(_templateObject2(), props.style.selectedColor);
}, function (props) {
  return props.style.bgHoverColor;
});
var StyledRadio = styled_components_1.default(Radio_1.default)(_templateObject3());

var MyOption = function MyOption(props) {
  var value = props.value,
      name = props.name,
      label = props.label,
      selected = props.selected,
      checkedIcon = props.checkedIcon,
      uncheckedIcon = props.uncheckedIcon,
      _props$selectedColor = props.selectedColor,
      selectedColor = _props$selectedColor === void 0 ? 'black' : _props$selectedColor,
      simple = props.simple,
      onChange = props.onChange,
      id = props.id;
  var optionStyles = {
    bgColor: '#f8f8f8',
    bgHoverColor: '#efefef',
    selectedColor: selectedColor
  };

  var handleChange = function handleChange() {
    onChange({
      name: name,
      value: value
    });
  };

  var radio = react_1.default.createElement(StyledRadio, {
    name: name,
    checked: selected,
    icon: react_1.default.createElement(__1.Icon, {
      color: "primary"
    }, uncheckedIcon),
    checkedIcon: react_1.default.createElement(__1.Icon, {
      color: "primary"
    }, checkedIcon),
    onChange: handleChange
  });

  if (simple) {
    radio = react_1.default.createElement(StyledRadio, {
      name: name,
      checked: selected,
      onChange: handleChange,
      color: "primary"
    });
  }

  return react_1.default.createElement(StyledFormControlLabel, {
    control: radio,
    label: label,
    id: id ? id : name,
    style: optionStyles,
    value: value
  });
};

exports.default = MyOption;